// Widget scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidgetSEO from './js/widgets/cardWidgetSEO.js';
import cardsMainTitle from './js/widgets/cardsMainTitle.js';
import cardWidgetCards from './js/widgets/cardWidgetCards.js';
import { facebookfeed, instafeed } from './js/widgets/socialNetworkWidget.js'; 
import cssSponsors from './js/widgets/cssSponsors.js';
import cardWidgetHistory from './js/widgets/cardWidgetHistory.js';
import cardWidgetFeaturedEvents from './js/widgets/cardWidgetFeaturedEvents.js';
// event mode widgets
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cardWidgetButtons from './js/widgets/cardWidgetButtons.js';
import cardWidgetImageGrid from './js/widgets/cardWidgetImageGrid.js';

// Custom theme scripts
import './js/localjs.js';



// Initialize homepage widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    swiperWidget();   
    cardWidgetFeaturedEvents();
    cardWidgetSEO();

    if (!$('body').hasClass('eventsMode')) {
      cardsMainTitle();
    }
    
    cardWidgetCards();
    facebookfeed(true);
    instafeed(true);
    cssSponsors();
    cardWidgetImageGrid();
    if (!$('body').hasClass('eventsMode')) {
      // multiScheduleFeature();
      cardWidgetButtons();
    }
  });
}

$(document).ready(function() {
  cardWidgetHistory();
});